export default __webpack_public_path__ + "static/media/equipe.da4d5a1b.jpg";